import { render, staticRenderFns } from "./review_list.vue?vue&type=template&id=5998af91&scoped=true"
import script from "./review_list.vue?vue&type=script&lang=js"
export * from "./review_list.vue?vue&type=script&lang=js"
import style0 from "./review_list.vue?vue&type=style&index=0&id=5998af91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5998af91",
  null
  
)

export default component.exports